export const getProviderLink = (dex: 'pump' | 'pumpfun' | 'bonk', mint: string) =>
    dex === 'bonk' ? `https://letsbonk.fun/token/${mint}` : `https://pump.fun/coin/${mint}`;
